
import React from 'react';
import {urlParamToObj} from "../../lib/url-util";
import CurrentOfferings from "./CurrentOfferings";

class CDContainer extends React.Component {

  componentDidMount() {
    this.updatePath();
  }

  componentDidUpdate() {
    this.updatePath();
  }

  getArgs = () => {
    return this.props.location.search
      ? urlParamToObj(this.props.location.search.substring(1))
      : {};
  }
  updatePath = () => {

    this.path = this.props.location.pathname;
    this.args = this.props.location.search
      ? urlParamToObj(this.props.location.search.substring(1))
      : {};
  }

  render = () => {
    if (!this.path) {
      this.updatePath();
    }

    const segment = this.path.split("/").pop();

    if (segment === "offerings") {
      return (<CurrentOfferings path={this.path} args={this.getArgs()}/>);
    }

    return (
      <div>
        No page here
      </div>
    )
  }

}

export { CDContainer };
